import React, { useState } from 'react'
import { BiChevronRight } from 'react-icons/bi'
import ActivationKey from '../../components/ActivationKey/ActivationKey'
import ContentInstructionsModal from '../../components/Modal/ContentInstructionsModal/ContentInstructionsModal'
import BoxArtModal from '../../components/Modal/BoxArtModal/BoxArtModal'

import './ArchivedRewards.scss'
import FormattedMessage from '../../components/FormattedMessage/FormattedMessage'

const ArchivedRewards = ({ archive }) => {
  const { name, couponKey, contentKey, staticKey, provider, boxImgName } = archive
  const [instructionModalOpen, setInstructionModalOpen] = useState(false)
  const [boxArtModalOpen, setBoxArtModalOpen] = useState(false)

  const handleToggleInstructionModal = () => {
    setInstructionModalOpen(true)
  }

  const handleToggleBoxArtModalOpen = () => {
    setBoxArtModalOpen(true)
  }

  return (
    <div className="pt-3 archived-rewards">
      <ContentInstructionsModal
        isOpen={instructionModalOpen}
        toggle={() => setInstructionModalOpen(!instructionModalOpen)}
        message={`contentProvider.${provider}.instruction.text`}
      />
      <BoxArtModal
        isOpen={boxArtModalOpen}
        toggle={() => setBoxArtModalOpen(!boxArtModalOpen)}
        imgUrl={boxImgName}
      />
      <div className="archived-item">
        <h4>{name}</h4>
        <p>
          <FormattedMessage id="global.label.rewardReference" /> - {couponKey}
        </p>
        <div className="achived-details">
          <div className="activation-key">
            <ActivationKey activationKey={contentKey} staticKey={staticKey} showLabel={false} />
          </div>
          <div className="archived-links">
            <div
              tabIndex={0}
              role="button"
              aria-label="Show Activation Instructions"
              onClick={handleToggleInstructionModal}
              onKeyDown={e => {
                if (e.key === 'Enter' || e.key === ' ') handleToggleInstructionModal()
              }}
            >
              <FormattedMessage id="page.redemptionPage.text.activationInstructions" />
              <BiChevronRight className="link-icon" />
            </div>
            <div
              tabIndex={0}
              role="button"
              aria-label="Preview Box Art"
              onClick={handleToggleBoxArtModalOpen}
              onKeyDown={e => {
                if (e.key === 'Enter' || e.key === ' ') handleToggleBoxArtModalOpen()
              }}
            >
              <FormattedMessage id="global.label.previewBoxArt" />
              <BiChevronRight className="link-icon" />
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default ArchivedRewards
